import { Fragment, useCallback } from 'react'
import { v4 as uuid } from 'uuid'
import { useRouter } from 'next/router'

import { Breakpoint, useCheckBreakpoint } from '~/utils/useBreakpoint'
import { GameChestContainer } from '~/components/GameChestContainer'
import { BootcampPageUrlParamsType, FunFactChestEventType } from '~/bootcamp/types/bootcamp.types'
import { useAppSelector } from '~/redux/hooks'
import { selectBootcampPageChest } from '~/bootcamp/slices/bootcamp-page.slice'
import { ChestSize } from '~/components/Chest/types'
import { useCreateFunFactChestEventMutation } from '~/redux/apis/activity-api'
import bootcampAnalytics from '~/analytics/bootcamp/bootcampAnalytics'
import { BCAEvent } from '~/analytics/bootcamp/bootcampEvents.types'

export function FunFactChest(): React.ReactElement {
  const isDesktop = useCheckBreakpoint({ gt: Breakpoint.XL })
  const isLargeDevice = useCheckBreakpoint({ gt: Breakpoint.LG })
  const [createChestEvent] = useCreateFunFactChestEventMutation()

  const { asPath, query, locale } = useRouter()
  const { action, key: bootcampKey, level, moduleKey } = query as unknown as BootcampPageUrlParamsType // May need to improve type here.
  const chest = useAppSelector(selectBootcampPageChest)

  const onChestClick = useCallback(() => {
    const event = {
      id: uuid(),
      viewKey: asPath,
      type: FunFactChestEventType.OPEN,
      time: new Date().toISOString(),
    }

    createChestEvent(event)

    bootcampAnalytics.log(BCAEvent.CLICK_FUN_FACT_CHEST, {
      locale,
      category: query.subtopic as string,
      subject: bootcampKey,
      bootcamp: moduleKey,
      bootcamp_page_type: action,
      level,
    })
  }, [asPath, bootcampKey, createChestEvent, locale, query, level, moduleKey, action])

  if (!chest || !chest.funfact) {
    return <Fragment />
  }

  const eventId = `bootcamp-${bootcampKey}-${moduleKey}-${level}-${action}`
  const size: ChestSize = isDesktop || isLargeDevice ? 'medium' : 'small'

  return (
    <GameChestContainer
      event={chest.event}
      eventId={eventId}
      funfact={chest.funfact}
      onClick={onChestClick}
      size={size}
    />
  )
}
